var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "confirm-modal",
    {
      ref: "modal",
      attrs: {
        title: "Удаление анкеты",
        confirm: "Удалить",
        reset: "Отменить",
        mode: "danger",
      },
      on: { confirm: _vm.confirm },
    },
    [
      _c("span", [
        _vm._v(" Анкета "),
        _c("b", [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" будет удалена без возможности восстановления "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }